import { styled } from '@f8n-frontend/stitches';

import Box from 'components/base/Box';
import ButtonWithCount from 'components/base/ButtonWithCount';
import ToggleButton from 'components/base/ToggleButton';

import { ApiNftMarketAvailability } from 'gql/api/types-api.generated';

import { NftFilters } from 'types/Nft';

import {
  BUY_NOW_FILTER,
  LIVE_AUCTION_FILTER,
  RESERVE_FILTER,
} from './api/MarketAvailabilityFilter';

type MarketAvailabilityFilterProps = {
  filters: NftFilters;
  setMarketAvailability: (marketAvailability: ApiNftMarketAvailability) => void;
};

export default function MarketAvailabilityFilter(
  props: MarketAvailabilityFilterProps
) {
  const { filters, setMarketAvailability } = props;

  const options = [LIVE_AUCTION_FILTER, BUY_NOW_FILTER, RESERVE_FILTER];

  return (
    <>
      {options.map((availabilityMode) => {
        return (
          <ToggleButton
            key={availabilityMode.value}
            size={0}
            type="button"
            variant="outline"
            pressed={filters.marketAvailability === availabilityMode.value}
            onClick={() => {
              setMarketAvailability(availabilityMode.value);
            }}
          >
            {availabilityMode.label}
          </ToggleButton>
        );
      })}
    </>
  );
}

export const MarketAvailabilityContainer = styled(Box, {
  // TODO: find a way to reuse these styles, with dynamic media queries
  gap: '$2',
  width: '100%',
  gridTemplateColumns: 'repeat(2, 1fr)',

  '@bp2-max': {
    display: 'grid',
    flexGrow: 1,

    [`& ${ButtonWithCount.Root}`]: {
      justifyContent: 'space-between',
    },
  },

  '@bp0': {
    display: 'flex',
  },

  '@bp1': {
    display: 'grid',
  },

  '@bp2': {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: 'auto',
  },
});
